import React from "react";
import {ModalHeader} from "reactstrap";
import "./modalDetailHeader.sass";
import NavigationButton from "../../atoms/button/navigationButton";
import {IconSource} from "../../../shared/enums/iconSource";
import {useTranslation} from "react-i18next";

export interface IModalDetailHeaderProps {
  toggle: () => void;
  children?: React.ReactNode;
  isLoading: boolean;
}

const ModalDetailHeader: React.FC<IModalDetailHeaderProps> = ({
  children,
  toggle,
  isLoading
}) => {
  const {t} = useTranslation(["translation"]);

  return (
    <ModalHeader
      toggle={toggle}
      close={<NavigationButton icon={IconSource.exit} onClick={toggle} />}
    >
      {isLoading ? t("translation:loading") : children}
    </ModalHeader>
  );
};

export default ModalDetailHeader;
